import { render, staticRenderFns } from "./SidInput.vue?vue&type=template&id=084175e8"
import script from "./SidInput.vue?vue&type=script&lang=js"
export * from "./SidInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports